<template>
  <div class="mstation-introduce-background">
    <div class="mstation-introduce-banner">
      <div class="mstation-introduce-container">
        <div class="mstation-introduce-banner-title">{{ $t("academic.title") }}</div>
      </div>

      <img class="mstation-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="mstation-introduce-container">

     <div class="mstation-introduce-content">
       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">{{ $t("academic.material") }}</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">
         <p class="mstation-introduce-content-info-text">{{ $t("academic.materialP1") }}</p>
        <div class="mstation-introduce-content-img">
         <img class="mstation-introduce-content-img-png" src="../../assets/solution/one-stop.png">
       </div>
       <p class="mstation-introduce-content-info-text">{{ $t("academic.materialP2") }}</p>



       </div>

       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">{{ $t("academic.solution") }}</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">

         <table class="mstation-introduce-table">
           <tr class="mstation-introduce-th">
             <th class="mstation-introduce-text-th">{{ $t("academic.solutionR0C1") }}</th>
             <th class="mstation-introduce-text-th">{{ $t("academic.solutionR0C2") }}</th>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR1C1") }}</td>
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR1C2") }}</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR2C1") }}</td>
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR2C2") }}</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR3C1") }}</td>
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR3C2") }}</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR4C1") }}</td>
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR4C2") }}</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR5C1") }}</td>
             <td class="mstation-introduce-text-td">{{ $t("academic.solutionR5C2") }}</td>
           </tr>
         </table>
       </div>

       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">{{ $t("academic.app") }}</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-img">
         <img class="paper-introduce-content-img-png" src="../../assets/solution/paper1.png">
         <img class="paper-introduce-content-img-png" src="../../assets/solution/paper2.png">
         <img class="paper-introduce-content-img-png" src="../../assets/solution/paper3.png">
         <img class="paper-introduce-content-img-png" src="../../assets/solution/paper4.png">
       </div>

       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">{{ $t("academic.partner") }}</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="home-cooperate-list">
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_1.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_2.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_3.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_4.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_5.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_6.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_7.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_8.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_9.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_10.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_11.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_12.png"></div>
      </div>


     </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "companyIntroduce"
  }
</script>

<style scoped>
  .mstation-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .mstation-introduce-background{
    margin-top: 70px;
  }
  .mstation-introduce-banner{
    overflow:hidden;
  }
  .mstation-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .mstation-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .mstation-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .mstation-introduce-content-img{
    text-align: center;
  }
  .mstation-introduce-content-img-png{
    margin-top: 10px;
    margin-bottom: 50px;
    width: 100%;
  }
  .paper-introduce-content-img-png{
    margin-top: 10px;
    margin-bottom: 30px;
    width: 100%;
  }
  .mstation-introduce-content-title{
    padding-top: 50px;
  }
  .mstation-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .mstation-introduce-content-info{
    margin-top: 40px;
  }
  .mstation-introduce-content-info-text{
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:30px;
  }
  .mstation-introduce-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .mstation-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .mstation-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .mstation-introduce-td{
    height: 45px;
  }
  .mstation-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .mstation-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-fa{
    font-size: 16px;
    padding-right: 8px;
  }

  .solution-border {
      width: 182px;
      height: 400px;
      margin: 30px 5px 0 5px;
      background-color:rgb(211, 211, 226)
    }
    .home-cooperate-list{
    margin-top: 10px;
    margin-left: -15px;
    margin-right: -15px;
    margin-bottom: 60px;
  }
  .home-cooperate-img-div{
    width: 200px;
    height: 90px;
    margin: 30px 15px 0px 15px;
    padding: 15px 0;
    display: inline-block;
    text-align: center;
  }
  .home-cooperate-img{
    max-width: 220px;
    max-height: 60px;
  }

  .mstation-introduce-content-img{
    text-align: center;
  }
  .mstation-introduce-content-img-png{
    margin-top: 20px;
    width: 100%;
  }

  @media screen and (max-width:482px) {
    .mstation-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .mstation-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .mstation-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .mstation-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .mstation-introduce-container{
      max-width: 1068px;
    }
  }

</style>